export default __webpack_public_path__ + "static/media/push13.73bf8550.gif";